import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type SortType } from '@/packages/api-models/common/json_query';
import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

import { type MapBounds } from '../mapConfiguration/slice';

export type MapControlsState = {
  activePin?: Cluster;
  activePinPage?: number;
  activePinSort: SortType;
  selectedBounds?: MapBounds;
  isCurrentAreaSearchActive: boolean;
};

const mapControlsInitialState: MapControlsState = {
  activePinSort: 'default',
  isCurrentAreaSearchActive: false,
};

export const { reducer: mapControlsReducer, actions: mapControlsActions } = createSlice({
  initialState: mapControlsInitialState,
  name: 'mapControls',
  reducers: {
    clearActivePin(state) {
      state.activePinSort = 'default';
      delete state.activePin;
      delete state.activePinPage;
    },
    clearSelectedBounds(state) {
      delete state.selectedBounds;
    },
    setActivePin(state, action: PayloadAction<Cluster>) {
      state.activePin = action.payload;
      state.activePinSort = 'default';
      delete state.activePinPage;
    },
    setActivePinPage(state, action: PayloadAction<number>) {
      state.activePinPage = action.payload;
    },
    setActivePinSortWithPageReset(state, action: PayloadAction<SortType>) {
      state.activePinSort = action.payload;
      delete state.activePinPage;
    },
    setIsCurrentAreaSearchActive(state, action: PayloadAction<boolean>) {
      state.isCurrentAreaSearchActive = action.payload;
    },
    setSelectedBounds(state, action: PayloadAction<MapBounds>) {
      state.selectedBounds = action.payload;
    },
  },
});
